import React from 'react';
import { FaBox, FaDownload, FaFilter, FaTimes } from 'react-icons/fa';
import { CLIENT_CATALOG } from '../../constant';

export default function ClientCatalogImportModal({
  onClose,
  showFiltersInModal,
  setShowFiltersInModal,
  searchTerm,
  setSearchTerm,
  filterOptions,
  onClearFilters,
  activeFilterCount,
  selectedProducts,
  toggleProductSelection,
  importableProducts,
  onImport,
  renderFilterSection,
}) {
  return (
    <div className="modal-backdrop">
      <div className="import-modal">
        <div className="modal-header">
          <h5 className="mb-0">{CLIENT_CATALOG.IMPORT_MODAL_TITLE}</h5>
          <button
            type="button"
            className="btn-close-client"
            onClick={onClose}
            aria-label={CLIENT_CATALOG.BTN_CANCEL}
          />
        </div>

        <div className="modal-body">
          <div className="modal-content-wrapper">
            <aside className={`modal-sidebar ${showFiltersInModal ? 'show' : ''}`}>
              <div className="sidebar-header">
                <h6 className="mb-0">{CLIENT_CATALOG.FILTERS_TITLE}</h6>
                <button
                  type="button"
                  className="btn-close-filters"
                  onClick={() => setShowFiltersInModal(false)}
                >
                  <FaTimes />
                </button>
              </div>

              <div className="filter-search mb-3">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder={CLIENT_CATALOG.SEARCH_PLACEHOLDER}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              {renderFilterSection(CLIENT_CATALOG.FILTER_CATEGORY, 'category', filterOptions.category)}
              {renderFilterSection(CLIENT_CATALOG.FILTER_PRODUCT_NAME, 'productName', filterOptions.productName)}
              {renderFilterSection(CLIENT_CATALOG.FILTER_FINISH, 'finish', filterOptions.finish)}
              {renderFilterSection(CLIENT_CATALOG.FILTER_COLOR, 'color', filterOptions.color)}
              {renderFilterSection(CLIENT_CATALOG.FILTER_SUITABLE_FOR, 'suitableFor', filterOptions.suitableFor)}
              {renderFilterSection(CLIENT_CATALOG.FILTER_MATERIAL, 'material', filterOptions.material)}
              {renderFilterSection(CLIENT_CATALOG.FILTER_COLLECTION, 'collection', filterOptions.collection)}
              {renderFilterSection(CLIENT_CATALOG.FILTER_PACK_TYPE, 'packType', filterOptions.packType)}

              {activeFilterCount > 0 && (
                <button type="button" className="btn btn-sm btn-outline-danger w-100" onClick={onClearFilters}>
                  {CLIENT_CATALOG.CLEAR_ALL_FILTERS}
                </button>
              )}
            </aside>

            <section className="modal-main-content">
              <div className="modal-topbar">
                <button
                  type="button"
                  className="btn-toggle-filters"
                  onClick={() => setShowFiltersInModal(!showFiltersInModal)}
                >
                  <FaFilter className="me-2" />
                  {CLIENT_CATALOG.BTN_FILTERS}{' '}
                  {activeFilterCount > 0 && `(${activeFilterCount})`}
                </button>
                <div className="selection-info">
                  <span>{CLIENT_CATALOG.SELECTED_COUNT(selectedProducts.size)}</span>
                </div>
              </div>

              <div className="import-products-grid">
                {importableProducts.length === 0 ? (
                  <div className="no-products">
                    <FaBox size={48} className="text-muted mb-3" />
                    <h6>{CLIENT_CATALOG.IMPORT_EMPTY_TITLE}</h6>
                    <p className="text-muted small">{CLIENT_CATALOG.IMPORT_EMPTY_HINT}</p>
                  </div>
                ) : (
                  importableProducts.map((product) => (
                    <div
                      key={product.uid}
                      role="button"
                      tabIndex={0}
                      className={`import-product-card ${selectedProducts.has(product.uid) ? 'selected' : ''}`}
                      onClick={() => toggleProductSelection(product.uid)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          toggleProductSelection(product.uid);
                        }
                      }}
                    >
                      <div className="product-image-container">
                        {product.images && product.images.length > 0 && product.images[0]?.path ? (
                          <img
                            src={product.images[0].path}
                            alt={product.itemNo || 'Product'}
                            className="product-image"
                          />
                        ) : (
                          <div className="product-image-placeholder">
                            <FaBox size={32} className="text-muted" />
                          </div>
                        )}
                        <div className="selection-checkbox">
                          <input
                            type="checkbox"
                            checked={selectedProducts.has(product.uid)}
                            onChange={(e) => {
                              e.stopPropagation();
                              toggleProductSelection(product.uid);
                            }}
                          />
                        </div>
                      </div>

                      <div className="product-info">
                        <div className="product-item-no">
                          <strong>{CLIENT_CATALOG.ITEM_NO_LABEL}</strong>
                          <span>{product.item_no || product.itemNo || CLIENT_CATALOG.NA}</span>
                        </div>
                        <p className="product-category text-muted small">
                          {product?.productName || CLIENT_CATALOG.NA}
                        </p>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </section>
          </div>
        </div>

        <div className="modal-footer">
          <button type="button" className="btn btn-outline-secondary" onClick={onClose}>
            {CLIENT_CATALOG.BTN_CANCEL}
          </button>
          <button type="button" className="btn btn-primary" onClick={onImport} disabled={selectedProducts.size === 0}>
            <FaDownload className="me-2" />
            {CLIENT_CATALOG.BTN_IMPORT}{' '}
            {selectedProducts.size > 0 && `(${selectedProducts.size})`}
          </button>
        </div>
      </div>
    </div>
  );
}
